// extracted by mini-css-extract-plugin
module.exports = {"prev":"PostNavigation-module--prev--21LoB","next":"PostNavigation-module--next--3bur2"};